import React, {useEffect, useState, useCallback} from 'react';

import Titulo from '../../components/Texto/Titulo';
import Pesquisa from '../../components/Inputs/Pesquisa';
import Paginacao from '../../components/Paginacao/Simples';

import {connect} from 'react-redux';
import {getClientes, getClientesPesquisa, buildClienteListQuery, removerCliente} from '../../actions/clientes';
import {Link, useHistory} from 'react-router-dom';
import { verifyDeveloper } from '../../utils/verify-admin';
import Loading from '../../components/Loading';
import * as XLSX from 'xlsx'; // Import all named exports from 'xlsx'
import {saveAs} from 'file-saver';
import axios from "axios";
import {api, versao} from "../../config";
import {getHeaders} from "../../actions/localStorage";

function Clients({clientes, admin, getClientes, getClientesPesquisa, removerCliente}) {
    const history = useHistory();
    const isDeveloper = verifyDeveloper(admin);

    const [pesquisa, setPesquisa] = useState("");
    const [paginationState, setPaginationState] = useState({current: 0, limit: 30});
    const [refreshing, setRefreshing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataInicio, setDataInicio] = useState("");
    const [dataFim, setDataFim] = useState("");
    const [tipoCadastro, setTipoCadastro] = useState("todos");
    const [filtrosAvancadosAbertos, setFiltrosAvancadosAbertos] = useState(false);

    const filtrosListagem = useCallback(() => {
        const f = {};
        if (dataInicio && dataFim) {
            f.dataInicio = dataInicio;
            f.dataFim = dataFim;
        }
        if (tipoCadastro && tipoCadastro !== "todos") {
            f.tipoCadastro = tipoCadastro;
        }
        return f;
    }, [dataInicio, dataFim, tipoCadastro]);

    function handleClients() {
        const termo = pesquisa.trim();
        const filtros = filtrosListagem();
        if (termo) getClientesPesquisa(termo, paginationState.current, paginationState.limit, admin.loja, filtros);
        else getClientes(paginationState.current, paginationState.limit, admin.loja, filtros);
    }

    useEffect(() => {
        if (admin && !clientes) handleClients();
    }, [])

    function refreshList() {
        setRefreshing(true);

        handleClients();

        const timer = setTimeout(() => {
            setRefreshing(false)
            clearTimeout(timer)
        }, 1800);
    }

    function handleSubmitPesquisa() {
        const termo = pesquisa.trim();
        setPaginationState((prev) => ({ ...prev, current: 0 }));
        const filtros = filtrosListagem();
        if (termo) {
            getClientesPesquisa(termo, 0, paginationState.limit, admin.loja, filtros);
        } else {
            getClientes(0, paginationState.limit, admin.loja, filtros);
        }
    }

    const aplicarFiltrosAvancados = () => {
        if ((dataInicio && !dataFim) || (!dataInicio && dataFim)) {
            alert("Informe data inicial e final para filtrar por período de cadastro, ou deixe as duas em branco.");
            return;
        }
        if (dataInicio && dataFim) {
            const a = new Date(dataInicio);
            const b = new Date(dataFim);
            if (a > b) {
                alert("A data inicial não pode ser maior que a data final.");
                return;
            }
        }
        setPaginationState((prev) => ({ ...prev, current: 0 }));
        const termo = pesquisa.trim();
        const filtros = filtrosListagem();
        if (termo) {
            getClientesPesquisa(termo, 0, paginationState.limit, admin.loja, filtros);
        } else {
            getClientes(0, paginationState.limit, admin.loja, filtros);
        }
    };

    const limparFiltrosAvancados = () => {
        setDataInicio("");
        setDataFim("");
        setTipoCadastro("todos");
        setPaginationState((prev) => ({ ...prev, current: 0 }));
        const termo = pesquisa.trim();
        if (termo) {
            getClientesPesquisa(termo, 0, paginationState.limit, admin.loja, {});
        } else {
            getClientes(0, paginationState.limit, admin.loja, {});
        }
    };

    const changeCurrent = (current) => {
        setPaginationState((prev) => ({ ...prev, current }));
        const termo = pesquisa.trim();
        const filtros = filtrosListagem();
        if (termo) {
            getClientesPesquisa(termo, current, paginationState.limit, admin.loja, filtros);
        } else {
            getClientes(current, paginationState.limit, admin.loja, filtros);
        }
    }


    const generateExcel = async () => {
        setLoading(true);
        try {
            const filtros = filtrosListagem();
            const totalExport = Number(clientes.total) || 0;
            const qs = buildClienteListQuery(admin.loja, 0, totalExport, filtros);
            const response = await axios.get(`${api}/${versao}/api/clientes?${qs}`, getHeaders());
            const clientesAll = response.data.clientes;

            const dados = (clientesAll?.docs || []).map(item => {
                const nameParts = item.nome.split(' ');
                const firstName = nameParts[0] || '';
                const lastName = nameParts.slice(1).join(' ') || '';

                return {
                    "Email": item.email,
                    "Phone": item.telefones[0],
                    "First name": firstName,
                    "Last name": lastName,
                    "Zip": '22705085',
                    "Country":"BR"
                };
            });

            // Create a new workbook
            const workbook = XLSX.utils.book_new();

            // Convert data to worksheet
            const worksheet = XLSX.utils.json_to_sheet(dados);

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');

            // Write workbook to a binary Excel file and save it
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(excelBlob, 'clientes.xlsx');
        } catch (error) {
            console.error("Error generating Excel file:", error);
        } finally {
            setLoading(false);
        }
    };


    const generateCSV = async () => {
        setLoading(true);
        try {
            const filtros = filtrosListagem();
            const totalExport = Number(clientes.total) || 0;
            const qs = buildClienteListQuery(admin.loja, 0, totalExport, filtros);
            const response = await axios.get(`${api}/${versao}/api/clientes?${qs}`, getHeaders());
            const clientesAll = response.data.clientes;

            const dados = (clientesAll?.docs || []).map(item => {
                const nameParts = item.nome.split(' ');
                const firstName = nameParts[0] || '';
                const lastName = nameParts.slice(1).join(' ') || '';

                return {
                    "Email": item.email,
                    "Phone": item.telefones[0],
                    "First name": firstName,
                    "Last name": lastName,
                    "Zip": '22705085',
                    "Country": "BR"
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(dados);
            const csv = XLSX.utils.sheet_to_csv(worksheet);

            // Create a blob and save the CSV file
            const csvBlob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob, 'clientes.csv');
        } catch (error) {
            console.error("Error generating CSV file:", error);
        } finally {
            setLoading(false);
        }
    };

    const deleteCliente = (item) => {
        if (!window.confirm(`Excluir permanentemente o cliente "${item.nome}"? Esta ação não pode ser desfeita.`)) return;
        removerCliente(item._id, admin.loja, () => refreshList());
    };

    return clientes ? (
        <div className="Clients">
            <div className="Page-Title">
                <Titulo tipo="h1" titulo="Clientes"/>
            </div>

            <div className="clientesToolbar">
                <div className="clientesToolbarTop">
                    <button
                        type="button"
                        className="clientesToolbarToggle"
                        onClick={() => setFiltrosAvancadosAbertos((v) => !v)}
                        aria-expanded={filtrosAvancadosAbertos}
                        aria-label="Abrir ou fechar filtros avançados"
                        title="Filtros avançados"
                    >
                        <div className={`icon icon-toggle${filtrosAvancadosAbertos ? " active" : ""}`}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </button>
                    <div className="clientesToolbarSearchWrap">
                        <Pesquisa
                            valor={pesquisa}
                            style={{ margin: 0 }}
                            placeholder="Pesquisar Cliente"
                            onChange={(ev) => setPesquisa(ev.target.value)}
                            onClick={() => handleSubmitPesquisa()}
                        />
                    </div>
                    <button type="button" title="Exportar CSV" className="btnIcon"
                            onClick={generateCSV}>
                        {loading ? <Loading/> : <i className="fas fa-file-alt" aria-hidden="true" />}
                    </button>
                    <button type="button" title="Exportar Excel (Facebook)" className="btnIcon"
                            onClick={generateExcel}>
                        {loading ? <Loading/> : <i className="fas fa-file-code" aria-hidden="true" />}
                    </button>
                    <Link to="/newclient">
                        <div className="btnIcon plus"></div>
                    </Link>
                </div>
                {filtrosAvancadosAbertos ? (
                    <div className="clientesFiltersDrawer">
                        <div className="entregasFiltersExtrasItems">
                            <label className="entregasFiltersPanel-field entregasFiltersPanel-field--date">
                                <span>Cadastro de</span>
                                <input
                                    type="date"
                                    value={dataInicio}
                                    onChange={(e) => setDataInicio(e.target.value)}
                                />
                            </label>
                            <label className="entregasFiltersPanel-field entregasFiltersPanel-field--date">
                                <span>Até</span>
                                <input
                                    type="date"
                                    value={dataFim}
                                    onChange={(e) => setDataFim(e.target.value)}
                                />
                            </label>
                            <label className="entregasFiltersPanel-field">
                                <span>Tipo de cadastro</span>
                                <select value={tipoCadastro} onChange={(e) => setTipoCadastro(e.target.value)}>
                                    <option value="todos">Todos</option>
                                    <option value="manual">Manual (painel)</option>
                                    <option value="online">Site / automático</option>
                                </select>
                            </label>
                        </div>
                        <div className="clientesFiltersDrawer-footer">
                            <button type="button" className="entregasLimparFiltrosBtn" onClick={limparFiltrosAvancados}>
                                Limpar filtros
                            </button>
                            <button type="button" className="clientesAplicarFiltrosBtn" onClick={aplicarFiltrosAvancados}>
                                Aplicar filtros
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
            {(dataInicio && !dataFim) || (!dataInicio && dataFim) ? (
                <p className="clientesFiltersHint">Para filtrar por período, preencha as duas datas (de e até).</p>
            ) : null}

            <div className={`Table Clients${isDeveloper ? ' Clients--developer' : ''}${refreshing ? ' refreshing' : ''}`}>
                <div className="head">
                    <div>Cliente</div>
                    <div>E-mail</div>
                    <div>Telefone</div>
                    <div>CPF</div>
                    <div>Cadastro</div>
                    {isDeveloper ? <div>Ações</div> : null}
                    <button type="button" className="refreshButton" onClick={refreshList}>
                        <i className="fas fa-redo"></i>
                    </button>
                </div>
                <div className="body">
                    {(clientes?.docs || []).map((item) => (
                        <div
                            key={item._id}
                            className={`item${item.manual ? ' manual' : ''}`}
                            onClick={() => history.push(`/cliente/${item._id}`)}
                            onKeyDown={(ev) => {
                                if (ev.key === 'Enter' || ev.key === ' ') {
                                    ev.preventDefault();
                                    history.push(`/cliente/${item._id}`);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            <span>{item.nome}</span>
                            <span>{item.email}</span>
                            <span>{item.telefones[0]}</span>
                            <span>{item.cpf}</span>
                            <span>
                                <span className="cliente-cadastro-badges">
                                    {item.manual ? (
                                        <span className="cliente-cadastro-badge cliente-cadastro-badge--manual" title="Cadastrado manualmente no painel">
                                            Manual
                                        </span>
                                    ) : (
                                        <span className="cliente-cadastro-badge cliente-cadastro-badge--site" title="Cadastro pelo site ou fluxo automático">
                                            Site
                                        </span>
                                    )}
                                </span>
                            </span>
                            {isDeveloper ? (
                                <span
                                    className="clientesTable-actions"
                                    onClick={(ev) => ev.stopPropagation()}
                                    onKeyDown={(ev) => ev.stopPropagation()}
                                >
                                    <button
                                        type="button"
                                        className="danger"
                                        title="Excluir cliente"
                                        aria-label={`Excluir cliente ${item.nome}`}
                                        onClick={() => deleteCliente(item)}
                                    >
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </span>
                            ) : null}
                        </div>
                    ))}
                </div>
            </div>

            {/*<Link className="btnIcon plus" onClick={handleAllClients}>Download transactions to csv</Link>*/}
            {/*<CSVLink data={clientes?.docs}  filename='clientes.csv'*/}
            {/*		 target='_blank'*/}
            {/*><div className="btnIcon fas fa-file" title={"Download CSV"}></div></CSVLink>*/}
            <Paginacao atual={paginationState.current} total={clientes?.total || 1} limite={paginationState.limit}
                       onClick={(numeroAtual) => changeCurrent(numeroAtual)}/>
        </div>
    ) : <Loading/>;
}

const mapStateToProps = state => ({
    clientes: state.cliente.clientes,
    admin: state.auth.usuario
});

export default connect(mapStateToProps, { getClientes, getClientesPesquisa, removerCliente })(Clients);
